/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import metadata from './PropertyDetailsAccordion.metadata.json5';
import styles from './PropertyDetailsAccordion.module.scss'

const PropertyDetailsAccordion = props => {
    const {
        yesNo,
        onTabChangeObj,
        getUrlAndOpen
    } = props;
    const [showReviewMSB, setShowReviewMSB] = useState(false)

    const mortgageeData = _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.mortgageeDetailsDTO');

    useEffect(() => {
        //checkMSBUrlAvailability()
    }, [])

    const onClickReviewMSB = useCallback(() => {
        const getUrl = getUrlAndOpen()
        const myWindow = window.open();
      
            getUrl.then((url) => {

                myWindow.location.href = url;
            });
        
        
    }, [getUrlAndOpen])

    const checkMSBUrlAvailability = useCallback(() => {
        const getUrl = getUrlAndOpen();
     
            if(!_.isUndefined(getUrl)){
                getUrl.then((url) => {
                    setShowReviewMSB(url.length > 0)
                });
            } 
     
              
    }, [getUrlAndOpen])

    const generateOverrides = useCallback(() => {
        if (!_.isUndefined(mortgageeData)) {

            const overrides = mortgageeData.map((item, index) => {
                return {
                    [`mortgageeValue${index}`]: {
                        content: <div className={styles.container}>
                            <div className={styles.header}>
                                <span>Name</span>
                                <span>Street</span>
                                <span>City</span>
                                <span>State</span>
                            </div>
                            <div className={styles.row}>
                                <span>{item.name}</span>
                                <span>{item.street}</span>
                                <span>{item.city}</span>
                                <span>{item.state}</span>
                            </div>
                        </div>
                    },
                };
            });

            return Object.assign({}, ...overrides);
        }

    }, [mortgageeData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        mortagageeSection: {
            data: mortgageeData
        },
        mortgageeDetails: {
            visible: !_.isUndefined(mortgageeData) && !_.isEmpty(mortgageeData)
        },
        fireplace: {
            value: yesNo(_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.fireplaceExists_Ext'))
        },
        woodstove: {
            value: yesNo(_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.woodstoveExists_Ext'))
        },
        swimmingPool: {
            value: yesNo(_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.swimmingPoolExists_Ext'))
        },
        trampoline: {
            value: yesNo(_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.trampolineExists_Ext'))
        },
        reviewMSB: {
            visible: showReviewMSB
        },
        ...generateOverrides()
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onClickReviewMSB,
            checkMSBUrlAvailability
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={onTabChangeObj}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


PropertyDetailsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}),
};
export default PropertyDetailsAccordion;
